import script from "./TipView.vue?vue&type=script&setup=true&lang=js"
export * from "./TipView.vue?vue&type=script&setup=true&lang=js"

import "./TipView.vue?vue&type=style&index=0&id=0b7da7be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b7da7be"]])

export default __exports__